


































































import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import { ReferalApi } from '../api';
import { Table } from '@/components/bwaff';
import moment from 'moment';
import { forEach } from 'lodash';

const numeralFormat = require('numeral');


@Component({
  components: {
    DataTable: Table
  }
})

export default class InvitedUsers extends Vue {
  @Prop()
  api: ReferalApi;

  @Prop({default: '$ 0,0.00'})
  format: string;

  @Prop({default:'DD MMM YYYY hh:mm'})
  dateFormat!: string;

  rows: any[] = [];
  rowsOnPage: number = 20;
  totalRows: number = 0;

  footer: any = {};

  referralPercent: any = this.$store.state.user.referralPercent;
  homepageUrl: string = `https://bemob.com/?ref=${this.$store.state.user.referralId}`;
  registerUrl: string = `https://bemob.com/?ref=${this.$store.state.user.referralId}&reg`;

  pagination: any = {
    descending:null,
    sortBy:null,
    rowsPerPage: this.rowsOnPage
  };

  getDescendingFormatted(descending: boolean | null){
    switch (descending){
      case true:
        return 'desc';
      case false:
        return 'asc';
      case null:
        default:
          return null;
    }
  }

  get headers() {
    const { t }  = this;
    return [
      { text: t('Email'), value: 'email',  sortable: true },
      { text: t('Registered at'), value: 'created', sortable: true },
      { text: t('Plan'), value: 'subscriptionPlan', sortable: true },
      { text: t('Last 30 Days Commission'), value: 'last30DaysCommission', sortable: true },
      { text: t('Total Commission'), value: 'totalCommission', sortable: true }
    ];
  }

  formatters: any = {
    last30DaysCommission:(h: Function, c: any, ctx: any, x: any) => {
      let count = numeralFormat(x.last30DaysCommission/100).format(this.format);
      return h('span', [count])
    },
    totalCommission:(h: Function, c: any, ctx: any, x: any) => {
      let count = numeralFormat(x.totalCommission/100).format(this.format);
      return h('span', [count])
    }
  };

  @Watch('api.dataReffer')
  dataReceived(data: any) {
    if(data.items) {
      this.rows = forEach(data.items, e => {
        e.created = e.created ? moment.utc(e.created).tz(this.$store.state.user.defaultTimezone).format(this.dateFormat) : '';
        return e;
      });
      this.totalRows = data.count;
    }
    this.footer = {
      email: this.t('Total invited') + ': ' + (data.count || 0),
      created: '',
      subscriptionPlan: '',
      last30DaysCommission: data.last30DaysCommission,
      totalCommission: data.totalCommission
    };
  }

  @Watch('pagination')
  paginationUpdated(currentState: any,previousState: any){
    const {page, rowsPerPage, descending, sortBy }= currentState;
    const orderDir = this.getDescendingFormatted(descending)

    this.api.getReferred({
      offset:(page-1)*rowsPerPage,
      limit:rowsPerPage,
      orderDir,
      orderBy:sortBy
    });
  }

  @Watch('$store.state.user')
  dataStore(val: any) {
    this.referralPercent = val.referralPercent;
    this.homepageUrl = `https://bemob.com/?ref=${val.referralId}`;
    this.registerUrl = `https://bemob.com/?ref=${val.referralId}&reg`;
  }
}
